import { render, staticRenderFns } from "./puzzle.vue?vue&type=template&id=4effa1c9"
import script from "./puzzle.vue?vue&type=script&lang=js"
export * from "./puzzle.vue?vue&type=script&lang=js"
import style0 from "./puzzle.vue?vue&type=style&index=0&id=4effa1c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports